(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["holiday-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('holiday-coupon')) {
    customElements.define('holiday-coupon', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[role="status"]');
        this.initialLabel = this.label.textContent;
        this.copyHandler = this.copyCode.bind(this);
        this.button.addEventListener('click', this.copyHandler);
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.copyHandler);
        clearTimeout(this.resetTimer);
      }

      async copyCode() {
        if (this.copying) return;
        this.copying = true;
        clearTimeout(this.resetTimer);

        try {
          try {
            await navigator.clipboard.writeText(this.dataset.code);
          } catch {
            this.copyWithSelection();
          }

          if (!this.isConnected) return;
          this.label.textContent = this.dataset.copied;
          this.status.classList.add('visually-hidden');
          this.status.textContent = this.dataset.copied;
          this.resetTimer = setTimeout(() => {
            this.label.textContent = this.initialLabel;
            this.status.textContent = '';
          }, 3000);
        } catch {
          this.label.textContent = this.initialLabel;
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.copyError;
        } finally {
          this.copying = false;
        }
      }

      copyWithSelection() {
        const previousFocus = document.activeElement;
        const field = document.createElement('textarea');
        field.value = this.dataset.code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);

        try {
          field.select();
          if (!document.execCommand('copy')) throw new Error('Copy failed');
        } finally {
          field.remove();
          previousFocus?.focus({ preventScroll: true });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-coupon-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flextail-product-coupons')) {
    class FlextailProductCoupons extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.timers = new Map();
        const { signal } = this.controller;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-code]');
          if (button && this.contains(button)) this.copy(button);
        }, { signal });
        window.addEventListener('load', () => this.updateCurrency(), { signal });
        window.addEventListener('pageshow', () => this.updateCurrency(), { signal });
        queueMicrotask(() => { if (this.isConnected) this.updateCurrency(); });
      }
      updateCurrency() {
        const { currency, storeCurrency } = this.dataset;
        const exchange = window.Shopify?.currency;
        const rate = currency === storeCurrency ? 1 : Number(exchange?.rate);
        if (currency !== storeCurrency && exchange?.active !== currency) return;
        if (!Number.isFinite(rate) || rate <= 0) return;
        let formatter;
        try {
          formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' });
        } catch { return; }
        const quantum = 100 / (10 ** formatter.resolvedOptions().maximumFractionDigits);
        this.querySelectorAll('[data-minimum]').forEach(tier => {
          const minimum = Number(tier.dataset.minimum);
          if (minimum <= 0) return;
          const amount = Math.ceil(minimum * rate / quantum - 1e-9) * quantum;
          tier.querySelector('.ftbfp-min').textContent = this.dataset.ordersOver.replace('__AMOUNT__', formatter.format(amount / 100));
        });
      }
      async copy(button) {
        const code = button.dataset.code;
        if (!code) return;
        let success = false;
        try {
          await navigator.clipboard.writeText(code);
          success = true;
        } catch {
          const input = document.createElement('textarea');
          const previousFocus = document.activeElement;
          input.value = code;
          input.setAttribute('readonly', '');
          input.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px';
          this.append(input);
          input.focus({ preventScroll: true });
          input.select();
          try { success = document.execCommand('copy'); } catch {}
          input.remove();
          if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
        }
        if (!this.isConnected || !button.isConnected) return;
        const label = button.querySelector('span');
        const status = this.querySelector('[role="status"]');
        clearTimeout(this.timers.get(button));
        status.classList.toggle('ftbfp-status--manual', !success);
        label.textContent = success ? this.dataset.copied : code;
        status.textContent = success ? this.dataset.success.replace('__CODE__', code) : `${this.dataset.manual} ${code}`;
        if (success) this.timers.set(button, setTimeout(() => {
          label.textContent = code;
          this.timers.delete(button);
        }, 1800));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.timers?.forEach(timer => clearTimeout(timer));
        this.querySelectorAll('[data-code]').forEach(button => { button.querySelector('span').textContent = button.dataset.code; });
      }
    }
    customElements.define('flextail-product-coupons', FlextailProductCoupons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-special-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-product-claim-form]');
    if (!trigger) return;
    event.preventDefault();
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', trigger.dataset.productClaimForm]);
  });
  } catch(e) { console.error(e); }
})();

})();
